export class SearchResult<T> {
    total!: number;
    items!: T[];
    totalList:any
}
